import type { ReactNode } from 'react';

import { cn } from '@mds/shared/lib/utils';

/**
 * The filter/CTA row that sits on the right of a card header. Filters come
 * first, the primary action last, and everything stays right-aligned when the
 * row wraps. On a phone it takes the card's full width and its controls share
 * each line rather than leaving a ragged edge: fields two to a line at most,
 * buttons never narrower than their label.
 */
export function Toolbar({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-end gap-2',
        'max-sm:w-full max-sm:*:flex-1 max-sm:[&>:not(button)]:min-w-[calc(50%-0.25rem)]',
        className,
      )}
    >
      {children}
    </div>
  );
}

/** The list/calendar style switch. Lives in shared now; kept importable from here. */
export { default as SegmentedToggle } from '@mds/shared/ui/segmented-toggle';
